import { render, staticRenderFns } from "./DialogConfirmationOtp.vue?vue&type=template&id=035eaa82&scoped=true"
import script from "./DialogConfirmationOtp.vue?vue&type=script&lang=js"
export * from "./DialogConfirmationOtp.vue?vue&type=script&lang=js"
import style0 from "./DialogConfirmationOtp.vue?vue&type=style&index=0&id=035eaa82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035eaa82",
  null
  
)

export default component.exports